import React, { Component } from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';

class QuickSearch extends Component {
    focusOnInput() {
        setTimeout(() => {
            this.searchInput && this.searchInput.focus();
        }, 0);
    }

    render () {
        const { query, result, showResult, showFullForm, onSearch, onBlur, onKeyDown, toggleShowFullForm, selectedItem, searchUrl } = this.props;
        const isCasallPro = document.body.classList.contains('casall-pro')
        
        return (
            <div className="quick-search" role="search">
                <a className="quick-search__link--block" onClick={e => {toggleShowFullForm(); this.focusOnInput()}}>
                    <i className="quick-search__icon"></i>
                    <span className="quick-search__title">{translate('general.search')}</span>
                </a>
                <div className={`quick-search__form ${showFullForm ? 'quick-search__form--force-show' : ''}`} role="search"> 
                    <input className="quick-search__input" type="search" placeholder={isCasallPro ? translate('general.searchPro') : translate('general.search')}
                        autoComplete="off" value={decodeURIComponent(query)} onChange={event => onSearch(encodeURIComponent(event.target.value))}
                        onKeyDown={event => onKeyDown(event, {searchUrl})} ref={(input) => { this.searchInput = input; }}
                        onBlur={() => onBlur() }/>
                    <button className="quick-search__submit-button" type="submit">
                        <img
                            className="icon"
                            src="/ui/images/search_black.svg"
                            alt="Search icon"
                        />
                    </button>
                    {showResult && <QuickSearchResult result={result} selectedItem={selectedItem} searchUrl={searchUrl}/>}
                </div>
            </div>
        )
    }
}

export default QuickSearch;
